import { Component } from '@angular/core';
import { environment } from '@environments/environment';
import { OktaAuth } from '@okta/okta-auth-js';
const oktaAuth = new OktaAuth(environment.okta);

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true
})
export class LoginComponent {

  constructor(){
    oktaAuth.signInWithRedirect();
  }

}
